import apiWorker from '../apiWorker'

const documents = {
    credit            : (data) => apiWorker('post', `/v1/api/documents/credit/${data.contact}/${data.company}/${data.access_code}`, data),
    connectedYodlee   : (data) => apiWorker('post', `/v1/api/documents/connected/yodlee/${data.contact}/${data.company}/${data.access_code}`, data),
    connectedMX       : (data) => apiWorker('post', `/v1/api/documents/connected/mx/${data.contact}/${data.company}/${data.access_code}`, data),
    connectedPinwheel : (data) => apiWorker('post', `/v1/api/documents/connected/pinwheel/${data.contact}/${data.company}/${data.access_code}`, data),
}

export default documents;